import { useQuery } from "@tanstack/react-query";
import { GetFeatureFlagClientAppEnum, GetFeatureFlagFeatureFlagEnum } from "@norma-bi/bi-api";
import { useAuthenticatedAPI } from "@/api";

export function useSFullApp() {
  const api = useAuthenticatedAPI();
  const flag = useQuery({
    queryKey: ["sFullApp"],
    queryFn: () =>
      api.getFeatureFlag({
        feature_flag: GetFeatureFlagFeatureFlagEnum.s_full_app,
        client_app: GetFeatureFlagClientAppEnum.web_app,
      }),
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
  return {
    enabled: flag.data?.enabled === true,
    isLoading: flag.isPending,
  };
}
